/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {Component, Input, ChangeDetectionStrategy} from '@angular/core';
import {StickyHeaderBaseComponent} from './sticky-header-base.component';

@Component({
    selector: 'app-sticky-header-simple-button',
    templateUrl: './sticky-header-simple-button.component.html',
    styleUrls: ['./sticky-header-simple-button.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class StickyHeaderSimpleButtonComponent extends StickyHeaderBaseComponent{
    @Input() text: string;
    @Input() click: () => void;
    @Input() class?: string;
    @Input() id?: string;
    @Input() tooltip?: string;
    @Input() icon?: string;
}
